import './App.css';
import React, { useEffect, useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Footer } from 'components/Footer';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'containers/Router';
import { isNewUIEnabled } from 'utils/utils';
import { userType } from 'actions/userType';
import { CsrAdminWrapper } from '@tfecom-thermofisher/csr-app-components/dist';
import Main from 'componentsV2/Main/Main';
import { userActions } from 'actions/login';
import config from 'constants/config';
import { isEmpty } from 'lodash-es';
import { assetType } from 'actions/assetTypes';
import ErrorBoundary from 'componentsV2/ErrorComponent/ErrorBoundary';

const userDetailsSession = JSON.parse(sessionStorage.getItem('userInfo'));

const App = () => {
  const dictionary = useSelector((state) => state.dictionary, shallowEqual);
  const unleashDetails = useSelector(
    (state) => state.getUnleashDetails.unleashDetails
  );
  const isLoading = useSelector((state) => state.getUnleashDetails.isLoading);
  const error = useSelector((state) => state.getUnleashDetails.error);
  const dispatch = useDispatch();
  const { userName, isAnonymous } =
    useSelector((state) => state?.userTypeReducer?.userType?.data) || {};
  const userTypeError =
    useSelector((state) => state?.userTypeReducer?.error) || null;
  const { serviceUrl } = config;
  const assetTypes = useSelector(
    (state) => state.assetTypeReducer?.assetTypes
  );
  const isNewUI = useMemo(() => {
    return isNewUIEnabled(unleashDetails, error, isLoading);
  }, [unleashDetails, error, isLoading, userDetailsSession?.isLoggedIn]);

  useEffect(() => {
    dispatch(userType.fetchUserType());
    const headerDiv = document.querySelector('.headerClassName');
      // Check if the headerDiv exists
      if (headerDiv) {
        // Get the sibling div above the headerDiv
        let previousSibling = headerDiv.previousElementSibling;
         // Traverse until a `<div>` tag is found or no sibling exists
        while (previousSibling && previousSibling.tagName !== 'DIV') {
          previousSibling = previousSibling.previousElementSibling;
        }

        if (previousSibling) {
          //apply styles to the sibling div     position: fixed;
          previousSibling.style.position = 'fixed';
          previousSibling.style.top = '-3px';
          previousSibling.style.left = '0';
          previousSibling.style.width = '100%';
          previousSibling.style.zIndex = '3';
          // Example style, you can change it as needed
          console.log('Sibling Div:', previousSibling);
        } else {
          console.log('No sibling div found above the headerDiv.');
        }
      } else {
        console.log('Div with class "headerClassName" not found.');
      }
  }, []);

  useEffect(() => {
    if(!location.hostname.includes('customercare.thermofisher.com')) {
        // redirect to
        window.location.href =
        (serviceUrl?.includes('localhost') || serviceUrl?.includes('qa'))
          ? 'https://qa1-customercare.thermofisher.com/store/admin'
          : 'https://customercare.thermofisher.com/store/admin';
        return;
    }
    else if (userName && !isAnonymous) {
      if (!unleashDetails) {
        dispatch(userActions.fetchUnleashDetails(userName));
      }
    } else if (userTypeError || isAnonymous) {
      // redirect to
      window.location.href =
        (serviceUrl?.includes('localhost') || serviceUrl?.includes('qa'))
          ? 'https://qa1-customercare.thermofisher.com/store/admin'
          : 'https://customercare.thermofisher.com/store/admin';
    }
  }, [userName, isAnonymous, userTypeError]);

  useEffect(() => {
    const fetchAssetTypes = async () => {
      try {
        await dispatch(assetType.fetchAssetTypes());
      } catch (error) {
        console.error('Error fetching asset types:', error);
      }
    };
    if (!assetTypes || isEmpty(assetTypes)) {
      fetchAssetTypes();
    }
  }, []);

  return (
    <div>
      <IntlProvider
        key={dictionary.locale}
        locale={dictionary.locale}
        messages={dictionary.messages}>
        <CsrAdminWrapper
          allowAnonymous
          pageTitle="Digital Asset Management"
          headerProps={{ showUsername: true }}
          headerClassName='headerClassName'
          contentClassName='contentClassName'
          >
          <BrowserRouter>
          <ErrorBoundary>
            {isNewUI ? (
              <>
                <Main />
                <Footer />
              </>
            ) : (
              <div className="app-component">
                <Routes />
                <Footer />
              </div>
            )}
            </ErrorBoundary>
          </BrowserRouter>
        </CsrAdminWrapper>
      </IntlProvider>
    </div>
  );
};

export default App;
